import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import profileImage from '../assets/dein-portrait.jpg';
import { FaMobileAlt, FaCode, FaRocket } from 'react-icons/fa';
import { SiReact, SiNodedotjs, SiFigma, SiJavascript, SiTypescript, SiCss3 } from 'react-icons/si';
import '../styles/AboutMePage.css'; // CSS-Import

// Eine Liste deiner Technologien für eine saubere Darstellung
const technologies = [
  { name: 'React', icon: <SiReact /> },
  { name: 'JavaScript (ES6+)', icon: <SiJavascript /> },
  { name: 'Node.js', icon: <SiNodedotjs /> },
  { name: 'TypeScript', icon: <SiTypescript /> },
  { name: 'CSS3 & SASS', icon: <SiCss3 /> },
  { name: 'Figma', icon: <SiFigma /> },
];

// Animations-Varianten
const containerVariants = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } }};
const itemVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }};

const AboutMePage = () => {
  return (
    <motion.div initial="hidden" animate="visible" variants={containerVariants}>
      
      <section className="about-page-hero section container">
        <motion.div variants={itemVariants}>
          <p style={{ color: 'var(--primary-color)' }}>Über Mich</p>
          <h1>Tobias Grimm</h1>
          <h3>Webdesigner & Entwickler aus Leipzig</h3>
          <p>Meine Leidenschaft ist es, Ideen in funktionale und ästhetisch ansprechende Webseiten zu verwandeln. Ich glaube daran, dass eine gute Webseite mehr ist als nur Code – sie ist das digitale Herz eines Unternehmens.</p>
        </motion.div>
        <motion.div variants={itemVariants}><img src={profileImage} alt="Portrait von Tobias Grimm" /></motion.div>
      </section>

      <section className="skills-section section">
        <div className="container">
          <h2 className="section-title">Meine <span>Philosophie</span></h2>
          <motion.div className="skills-grid" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
            <motion.div className="skill-card" variants={itemVariants}><div className="skill-icon"><FaMobileAlt /></div><h4>Responsive Design</h4><p>Ihre Webseite sieht auf jedem Gerät perfekt aus.</p></motion.div>
            <motion.div className="skill-card" variants={itemVariants}><div className="skill-icon"><FaCode /></div><h4>Sauberer Code</h4><p>Ich schreibe modernen, wartbaren Code für schnelle Ladezeiten und Stabilität.</p></motion.div>
            <motion.div className="skill-card" variants={itemVariants}><div className="skill-icon"><FaRocket /></div><h4>Nutzer im Fokus</h4><p>Ich designe für eine intuitive und angenehme Nutzererfahrung.</p></motion.div>
          </motion.div>
        </div>
      </section>

      <section className="section tech-stack-section">
        <div className="container">
          <h2 className="section-title">Technologien, <span>die ich nutze</span></h2>
          <motion.div 
            className="tech-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {technologies.map((tech, index) => (
              <motion.div key={index} className="tech-card" variants={itemVariants}>
                <div className="tech-card-icon">{tech.icon}</div>
                <span>{tech.name}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <section className="section about-page-cta">
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <h2 className="section-title" style={{marginBottom: '1rem'}}>Haben Sie ein Projekt im Kopf?</h2>
            <p className="section-subtitle" style={{marginBottom: '2rem'}}>Lassen Sie uns darüber sprechen, wie ich Ihnen helfen kann.</p>
            <Link to="/#kontakt" className="cta-button">Jetzt Kontakt aufnehmen</Link>
          </motion.div>
        </div>
      </section>

    </motion.div>
  );
};

export default AboutMePage;